import { defineStore } from "pinia";
import { RouteRecordRaw } from 'vue-router';
import { routes as staticRoutes } from '@/router';
import { Local } from '@/utils/storage';

export const silderStore = defineStore('silderbar', {
    state: () => {
        return {
            collapse: false,
            routers: staticRoutes,
            bgcolor: '#304156',
            isDynamic: false // 标记是否已加载动态路由
        };
    },
    actions: {
        toggleOpen() {
            this.collapse = !this.collapse;
        },
        // 设置动态路由
        setDynamicRouters(dynamicRouters: RouteRecordRaw[]) {
            this.routers = dynamicRouters;
            this.isDynamic = true;
        },
        // 根据权限过滤路由
        filterRoutersByPermission(allRouters: RouteRecordRaw[], permissionCodes: string[]): RouteRecordRaw[] {
            const filteredRouters: RouteRecordRaw[] = [];
            
            allRouters.forEach(route => {
                // 深拷贝避免修改原路由
                const routeCopy = JSON.parse(JSON.stringify(route));
                
                // 如果有 meta.permission，检查是否有对应权限
                if (routeCopy.meta?.permission) {
                    const requiredPermission = routeCopy.meta.permission;
                    if (!permissionCodes.includes(requiredPermission)) {
                        return; // 没有权限，跳过此路由
                    }
                }
                
                // 处理子路由
                if (routeCopy.children && routeCopy.children.length > 0) {
                    routeCopy.children = this.filterRoutersByPermission(routeCopy.children, permissionCodes);
                    
                    // 如果子路由为空且不是父级菜单，则删除该路由
                    if (routeCopy.children.length === 0 && !routeCopy.alwaysShow) {
                        return;
                    }
                }
                
                filteredRouters.push(routeCopy);
            });
            
            return filteredRouters;
        },
        // 初始化路由（从缓存或重新加载）
        initRouters() {
            const cachedRouters = Local.get('dynamicRouters');
            if (cachedRouters && cachedRouters.length > 0) {
                this.routers = cachedRouters;
                this.isDynamic = true;
            } else {
                this.routers = staticRoutes;
                this.isDynamic = false;
            }
        }
    }
});

export interface IsilderBar {
    collapse: boolean;
    routers: RouteRecordRaw[];
    bgcolor: string;
    isDynamic: boolean;
}
